import { useSubscription } from '~/stores/use-subscription/useSubscription';

export const useIsEarningsInsightsEnabled = () => {
  const isTerminal = useSubscription(
    state => state.isFromBO() || state.isTerminal()
  );

  return isTerminal;
};
